import {Component, OnInit, Output, EventEmitter, AfterViewInit, ViewChild, ElementRef} from '@angular/core';
import {LoginService} from '../../shared/services/login.service';
import {ActivatedRoute, Router, Params} from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit, AfterViewInit {
  @ViewChild('focusInput') focusInputElement: ElementRef;
  isRequesting: boolean;
  token: string;
  newPassword: string;
  confirmPassword: string;
  validationSummary: string;
  @Output()
  change = new EventEmitter<boolean>();

  constructor(private loginService: LoginService, private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.token = params['token'];
    });

    this.confirmPassword = '';
    this.newPassword = '';
  }

  ngAfterViewInit(): void {
    this.focusInputElement.nativeElement.focus();
  }

  get areNewAndConfirmPasswordSame(): boolean {
    if (this.confirmPassword.length === 0 && this.newPassword.length === 0 ) {
      return false;
    }

    return  this.confirmPassword === this.newPassword;
  }

  updatePassword(): void {

    if (!this.areNewAndConfirmPasswordSame) {
      this.validationSummary = 'New Password and Re-enter New Password are not same.';
      return;
    }
    this.isRequesting = true;
    this.loginService.updatePassword(this.token, this.newPassword).subscribe(ok => {
        this.isRequesting = false;
        this.validationSummary = 'Confirmation email has been sent.';
        if (typeof (ok) === 'boolean') {
          this.change.emit(ok);
        }
      },
      err => {
      this.isRequesting = false;
      let message: string = err.error.err.toString();
      const splitedMessage: string[] = message.split(',');
      if (splitedMessage.length > 0) {
        message = splitedMessage.join('\n');
      }

      this.validationSummary = message;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/manage-users/reset-password/reset-password.component.ts